import { BarCodeType } from "./BarCodeType";
import { IHealthScanResult } from "./IHealthScanResult";

export interface IHealthCardParser {
    Parse(barcodeInformation: string): IHealthScanResult | null;
}

export abstract class BaseHealthCardParser implements IHealthCardParser {
    public Parse(barcodeInformation: string): IHealthScanResult {
        if (!barcodeInformation) {
            return {
                hasResult: false
            };
        }

        const oneDimensionRegex = this.GetOneDimensionRegex();

        if (barcodeInformation.match(oneDimensionRegex)) {
            return {
                hasResult: true,
                healthCardNumber: barcodeInformation,
                barcodeType: BarCodeType.OneDimension
            };
        }

        for (const regex of this.GetTwoDimensionRegex()) {
            if (barcodeInformation.match(regex)) {
                const result: RegExpMatchArray = barcodeInformation.match(regex);

                const healthCardNumber = this.GetHealthCardNumber(result);

                return {
                    hasResult: !!healthCardNumber,
                    healthCardNumber,
                    barcodeType: BarCodeType.TwoDimension
                };
            }
        }

        return {
            hasResult: false
        };
    }

    protected abstract GetOneDimensionRegex(): RegExp;

    protected abstract GetTwoDimensionRegex(): RegExp[];

    protected GetHealthCardNumber(result: RegExpMatchArray): string | null {
        return result.groups["HealthCareNumber"] || null;
    };
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/BaseHealthCardParser.ts